import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-37aac352")

_pushScopeId("data-v-37aac352")
const _hoisted_1 = { class: "InvoiceAdditional" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "InvoiceAdditional__title" }, "Дополнительная информация", -1)
const _hoisted_3 = { class: "InvoiceAdditional__body" }
const _hoisted_4 = { class: "body__row" }
const _hoisted_5 = { class: "body__block" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Способ оплаты", -1)
const _hoisted_7 = { class: "block__text" }
const _hoisted_8 = {
  key: 0,
  class: "body__block"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Сумма наличными", -1)
const _hoisted_10 = { class: "block__text" }
const _hoisted_11 = {
  key: 1,
  class: "body__block"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Контрольная дата прибытия", -1)
const _hoisted_13 = { class: "block__text" }
const _hoisted_14 = { class: "body__block" }
const _hoisted_15 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Сторона оплаты", -1)
const _hoisted_16 = { class: "block__text" }
const _hoisted_17 = { class: "body__block" }
const _hoisted_18 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Наложенный платёж", -1)
const _hoisted_19 = { class: "block__text" }
const _hoisted_20 = {
  key: 2,
  class: "body__block"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Дата создания", -1)
const _hoisted_22 = { class: "block__text" }
const _hoisted_23 = { class: "body__block" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Примечания к отправке", -1)
const _hoisted_25 = { class: "block__text" }
const _hoisted_26 = { class: "body__block" }
const _hoisted_27 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Возвратные документы", -1)
const _hoisted_28 = { class: "block__text" }
const _hoisted_29 = { class: "body__block" }
const _hoisted_30 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Температурный режим", -1)
const _hoisted_31 = { class: "block__text" }
const _hoisted_32 = { class: "body__block" }
const _hoisted_33 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Опасный груз", -1)
const _hoisted_34 = { class: "block__text" }
const _hoisted_35 = { class: "body__block" }
const _hoisted_36 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Наличие батарейки/аккумулятора", -1)
const _hoisted_37 = { class: "block__text" }
const _hoisted_38 = { class: "body__block" }
const _hoisted_39 = /*#__PURE__*/_createVNode("p", { class: "block__subtext" }, "Наличие автозапчастей", -1)
const _hoisted_40 = { class: "block__text" }
const _hoisted_41 = {
  key: 3,
  class: "body__files"
}
const _hoisted_42 = {
  key: 4,
  class: "body__files"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_uploaded_file = _resolveComponent("uploaded-file")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.invoiceState.data.payment_method), 1)
        ]),
        (Boolean(_ctx.invoiceState.data.cash_sum))
          ? (_openBlock(), _createBlock("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("p", _hoisted_10, _toDisplayString(_ctx.invoiceState.data.cash_sum + ' ₸'), 1)
            ]))
          : _createCommentVNode("", true),
        (Boolean(_ctx.invoiceStatusesState.client_sla_date))
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _hoisted_12,
              _createVNode("p", _hoisted_13, _toDisplayString(_ctx.invoiceStatusesState.client_sla_date), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode("p", _hoisted_16, [
            (_ctx.invoiceState.data.payer_company)
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoiceState.data.payment_type) + " ", 1),
                  (_ctx.invoiceState.data.payer_company && !_ctx.invoiceState.data.payer_company.includes('ЧЛ'))
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" (" + _toDisplayString(_ctx.invoiceState.data.payer_company) + ") ", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.invoiceState.data.payment_type), 1)
                ], 64))
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode("p", _hoisted_19, _toDisplayString(_ctx.invoiceState.data.cod_payment || 0) + " т", 1)
        ]),
        (_ctx.invoiceState.data.created_at)
          ? (_openBlock(), _createBlock("div", _hoisted_20, [
              _hoisted_21,
              _createVNode("p", _hoisted_22, _toDisplayString(_ctx.invoiceState.data.created_at), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_23, [
          _hoisted_24,
          _createVNode("p", _hoisted_25, _toDisplayString(_ctx.invoiceState.data.annotation || 'Нет данных'), 1)
        ]),
        _createVNode("div", _hoisted_26, [
          _hoisted_27,
          _createVNode("p", _hoisted_28, _toDisplayString(_ctx.invoiceState.data.should_return_document ? 'Да' : 'Нет'), 1)
        ]),
        _createVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode("p", _hoisted_31, _toDisplayString(_ctx.invoiceState.data.temperature_regime
                                ? _ctx.invoiceState.data.temperature_regime.title
                                : 'Не указан'), 1)
        ]),
        _createVNode("div", _hoisted_32, [
          _hoisted_33,
          _createVNode("p", _hoisted_34, _toDisplayString(_ctx.invoiceState.data.is_dangerous ? 'Да' : 'Нет'), 1)
        ]),
        _createVNode("div", _hoisted_35, [
          _hoisted_36,
          _createVNode("p", _hoisted_37, _toDisplayString(_ctx.invoiceState.data.has_battery ? 'Да' : 'Нет'), 1)
        ]),
        _createVNode("div", _hoisted_38, [
          _hoisted_39,
          _createVNode("p", _hoisted_40, _toDisplayString(_ctx.invoiceState.data.has_auto_parts ? 'Да' : 'Нет'), 1)
        ]),
        (_ctx.invoiceState.data.is_dangerous)
          ? (_openBlock(), _createBlock("div", _hoisted_41, [
              _createVNode(_component_uploaded_file, {
                "is-visible": _ctx.isInvoiceFiles,
                files: _ctx.invoiceState.data.invoice_files,
                title: "Файлы накладной",
                "no-delete": ""
              }, null, 8, ["is-visible", "files"]),
              _createVNode(_component_uploaded_file, {
                "is-visible": _ctx.isCertificate,
                files: _ctx.invoiceState.data.certificate_of_safety_files,
                title: "Сертификаты безопасности",
                "no-delete": ""
              }, null, 8, ["is-visible", "files"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.invoiceState.data.temperature_regime_safety_files)
          ? (_openBlock(), _createBlock("div", _hoisted_42, [
              _createVNode(_component_uploaded_file, {
                "is-visible": _ctx.invoiceState.data.temperature_regime_safety_files.length,
                files: _ctx.invoiceState.data.temperature_regime_safety_files,
                title: "Паспорт безопасности температурного режима",
                "no-delete": ""
              }, null, 8, ["is-visible", "files"])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})